// extracted by mini-css-extract-plugin
export default {"Wrapper":"AppLayout_Wrapper__5OZHi","Sidebar":"AppLayout_Sidebar__UjMFR","Main":"AppLayout_Main__fryAR","SideBorder":"AppLayout_SideBorder__XAZNz"};